<template>
  <Modal
    name="CHANGE_DATE_MODAL"
    :title="$t('appointment.adminActions.changeDate.action')"
    actions
  >
    <template v-slot:body>
      <div>
        <v-alert type="warning">
          {{ $t('appointment.adminActions.changeDate.warningMessage') }}
        </v-alert>

        <v-form ref="appointmentChangeDateForm" lazy-validation>
          <v-row class="mb-3">
            <v-col cols="6" md="8">
              <SelectDate
                v-model="date"
                :data="appointment.date"
                :rules="[rules.required]"
                :label="$t('appointment.reschedule.date')"
                :minDate="today"
                ref="appointmentDate"
              />
            </v-col>
            <v-col cols="6" md="4">
              <SelectHour
                v-model="hour"
                :date="date"
                :data="appointment.date"
                :rules="[rules.required]"
                :label="$t('appointment.reschedule.hour')"
                limitHours
              />
            </v-col>
          </v-row>
        </v-form>
      </div>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeAllModals"
        :disabled="isLoading || isChangingDateAndTime"
        elevation="0"
        class="mr-5"
        large
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        @click="changeDate"
        :loading="isLoading || isChangingDateAndTime"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('appointment.adminActions.changeDate.action') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>
import moment from 'moment'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { required } from '@/util/errorHandling'
import { dateHourTimezone } from '@/util/catalog'

import Modal from '@/components/app/Modal'
import SelectDate from '@/components/date/SelectDate'
import SelectHour from '@/components/date/SelectHour'

export default {
  name: 'AdminAppointmentQuoteReopen',
  components: {
    Modal,
    SelectDate,
    SelectHour
  },
  data() {
    return {
      date: null,
      hour: null,
      rules: {
        required,
      },
      today: moment().format('YYYY-MM-DD'),

      isChangingDateAndTime: false,
    }
  },
  computed: {
    ...mapGetters(['appointment', 'isLoading']),
  },
  methods: {
    ...mapActions(['changeAppointmentDate']),
    ...mapMutations(['closeAllModals']),

    changeDate() {
      this.isChangingDateAndTime = true

      const date = this.date
        ? moment(this.date).format('YYYY-MM-DD')
        : moment(this.appointment.date).format('YYYY-MM-DD')

      const hour = this.hour
        ? this.hour.replace(' ', '')
        : moment(this.appointment.date).format('HH:mm')

      const payload = {
        appointment_id: this.appointment.id,
        new_date: new Date(dateHourTimezone(date, hour)),
      }

      this.changeAppointmentDate(payload)
        .then(() => {
          if (this.$parent?.refreshMap) this.$parent?.refreshMap()
          if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
        })
        .then(() => this.closeAllModals())
        .finally(() => this.isChangingDateAndTime = false)
    },
  },
}
</script>
